<template>
    <FormSection
        :title="`Add Referral Documents for ${referral.lastName}, ${referral.firstName} `"
        :full-height="true"
        :show-product-pill="true"
        :application-id="referral.application"
    >
        <template #content>
            <div class="d-flex flex-column px-3 py-3">
                <HHPatientDocuments
                    :upload-document="uploadDocument"
                    :delete-document="deleteDocument"
                    :get-documents="getReferralDocuments"
                    :referral="referral"
                />
                <footer class="d-flex justify-content-center">
                    <button
                        @click="closeAddDocumentsDialog()"
                        type="button"
                        class="btn btn-xs me-2 btn-outline-primary"
                    >
                        Close
                    </button>
                </footer>
            </div>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./HHReferralDocuments.ts"></script>
